/**
 * Made-up people who have already marked themselves into groups, for the
 * Gathering admin view's "sample data" mode — so the room planner can be
 * tried before anyone on the node has joined. Shaped like the admin API
 * response (pods/gatherings), and never written to it.
 */

const FIRST = ['Ada', 'Bilal', 'Chen', 'Dara', 'Esme', 'Farah', 'Gus', 'Hana', 'Ivo', 'Jun', 'Kemi', 'Leo',
    'Mira', 'Nico', 'Omar', 'Priya', 'Quinn', 'Rosa', 'Sami', 'Tova', 'Uma', 'Vik', 'Wren', 'Yara',
    'Zeke', 'Anouk', 'Bea', 'Cato', 'Dev', 'Elif', 'Finn', 'Gaia', 'Hugo', 'Isla', 'Jonah', 'Kira'];
const LAST = ['Okafor', 'Lindqvist', 'Moreau', 'Tanaka', 'Haddad', 'Novak', 'Reyes', 'Bauer', 'Singh', 'Costa'];

export const SAMPLE_PEOPLE = FIRST.map((first, i) => ({
    id: -(i + 1),
    name: `${first} ${LAST[(i * 7) % LAST.length]}`,
    entity_type: 'person',
}));

export const SAMPLE_GROUPS = [
    { id: 's1', name: 'Engineers', color: 0, seats_per_room: 2 },
    { id: 's2', name: 'Designers & researchers', color: 1, seats_per_room: 1 },
    { id: 's3', name: 'London', color: 2, seats_per_room: 0 },
    { id: 's4', name: 'Newcomers', color: 3, seats_per_room: 1 },
];

// Deterministic and deliberately lopsided (plenty of engineers, fewer
// designers) with some people in several groups, so the planner has both a
// scarce group and overlap to work around.
const PICKS = [
    ['s1'], ['s1', 's3'], ['s2'], ['s1', 's4'], [], ['s2', 's3'], ['s1'], ['s2', 's4'], ['s3'],
    ['s1', 's3', 's4'], ['s2'], ['s4'],
];
export const SAMPLE_MEMBERSHIPS = SAMPLE_GROUPS.reduce((acc, g) => ({
    ...acc,
    [g.id]: SAMPLE_PEOPLE.filter((_, i) => PICKS[i % PICKS.length].includes(g.id)).map(p => p.id),
}), {});

// Five topics for the sample's seven rooms, so the loop back to topic 1
// shows on rooms 6 and 7.
export const SAMPLE_TOPICS = [
    'What surprised you most this month?',
    'Which tool or habit would you recommend to everyone here?',
    'What is one thing our community should try next?',
    'What are you working on that you’d like help with?',
    'Who has influenced how you work, and how?',
].map((text, i) => ({ id: `t${i + 1}`, text }));

// The flow from the product brief: everyone together, two breakout rounds
// (the second a reshuffle of the first), then back together.
export const SAMPLE_FLOW = [
    { id: 'f1', kind: 'common', duration_minutes: 20, seed: 0 },
    { id: 'f2', kind: 'breakout', duration_minutes: 30, seed: 1 },
    { id: 'f3', kind: 'breakout', duration_minutes: 20, seed: 2 },
    { id: 'f4', kind: 'common', duration_minutes: 10, seed: 0 },
];
